import React, { useEffect, useState } from "react";
import Breadcrumb from "../../Components/Breadcrumb/Breadcrumb";
import AllAcountsSection from "../../Components/AllAccountsSection/AllAcountsSection";
import { AiFillCaretRight, AiOutlineArrowRight, AiOutlineArrowUp } from "react-icons/ai";
import SavePlusAccountComponent from "../../Components/SavePlusAccount/SavePlusAccountComponent";
import ContainsArea from "../../Components/ContainsArea/ContainsArea";

const HouseholdContentsInsurance = () => {
  const BackgroundBrundcrumb = "https://izbassetsmain.blob.core.windows.net/izbwebassets/indo-home-loan-banner.png";
  const img1 = "https://izbassetsmain.blob.core.windows.net/izbwebassets/HouseholdContentsInsuranceNew.png";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const accountContent = "Household contents such as furniture, appliances, clothing, excluding laptops, phones, digital cameras, tablets and other mobile devices.";

  
  const [openIndex, setOpenIndex] = useState(null);


  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const accordionData = [
    {
      title: "Features",
      content: [
        "Riot and civil commotion (non-political)", 
        "Power surges and indirect lighting strikes – Excluding Power utility company scheduled operational/ load shedding programs",
        "Liability to domestic workers – covered upto the limit per insurer",
        "Transit risks cover contingent upon permanent change of residence- with Zambia only",
        "Deep freezer contents – limited to k1,000.00 per event/annual aggregate",
        "10% Minimum K500.00 each and every claim including theft claims"
    ],
    },
    {
      title: "Requirements ",
      content: [
        "A detailed schedule of items to be insured",
        "Serial numbers for electronic or electric items",
        "Correct replacement values per item ",
        "Physical address"
      ],
    },
    {
      title: "Some Notable Exclusions Among Other",
      content: [
        "Wear and tear", 
        "Mechanical, electronic or electrical faults", 
        "Unexplained or misterious losses", 
        "Willful acts", 
        "Consequential loss", 
        "Political, terrorism and war risks"
      ],
    },
    {
      title: "Basis of cover",
      content: ["Accidental physical loss or damage to the insured item by the insured perils, fire, theft, impact etc."],
    },
    {
      title: "Settlement",
      content: ["Replacement or reinstatement value"],
    },
    {
      title: "How to Apply",
      content: ['To apply now, email <a href="mailto:bancassurance@izb.co.zm">bancassurance@izb.co.zm</a> or call <a href="tel:8002">8002</a>'],
    }
  ];

  return (
    <>
       <section className="HouseholdContentsInsuranceSection">
        <Breadcrumb Heading="Household Contents Insurance" img={BackgroundBrundcrumb} show={true} btnTxt="Apply Now" />
       </section>

       <SavePlusAccountComponent heading="Household Contents Insurance" subHeading="Know About" btnTxt="Apply Now" content={accountContent} img={img1} logo={true} />
       {/* <ContainsArea /> */}

        <section>
            <div className="container">
            <div className="row">
                <div className="col-xl-12 justify-content-center">
                <div className="faq-style1__content">
                    <ul className="accordion-box mt-2">
                        {accordionData.map((item, index) => (
                            <li className="accordion block active-block" key={index}>
                                <div
                                    className="acc-btn active"
                                    style={{ backgroundColor: "#9E1B1E", backgroundSize: "20px" }}
                                    onClick={() => handleToggle(index)}
                                >
                                    <div className="icon-outer text-white">
                                        {openIndex === index ? <AiOutlineArrowRight /> : <AiOutlineArrowUp />}
                                    </div>
                                    <h3 className="text-white">{item.title}</h3>
                                </div>
                                {openIndex === index && (
                                    <div className="acc-content current px-5">
                                        {item.content.map((point, idx) => (
                                            <p key={idx} className="">
                                                <AiFillCaretRight className="me-1 accordion-icon" />
                                                <span className="mt-1" dangerouslySetInnerHTML={{ __html: point }} />
                                            </p>
                                        ))}
                                    </div>
                                )}
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p style={{ paddingLeft: "0px", paddingBottom: "50px", paddingTop: "20px",  color: "#9e1b1e" }}>
                    <strong>
                        <em>Note: All Solar Items are to be insured under – Plant all Risk Policy</em>
                    </strong>
                    </p>
                </div>
                </div>
            </div>
            </div>
        </section>

       <AllAcountsSection />
    </>
  );
};

export default HouseholdContentsInsurance;